import ApiBack from "../../../utils/domains/ApiBack";
import IPS from "../../../models/Ips";
import IPSView from "../../../models/ipsView";
import Municipio from "../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../services/ServicePrivate";
import { Button, Form, Modal } from "react-bootstrap";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { useForm } from "../../../utils/hooks/useForm";
import { useRef } from "react";
import Deparment from "../../../models/Deparment";
import User from "../../../models/user";
import { jwtDecode } from "jwt-decode";
import { Bell } from "lucide-react";
import EPS from "../../../models/SupportInformation/EPS";
import TypeReport from "../../../models/SupportInformation/TypeReport";

export const ListTypeReport = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [process, setProcess] = useState<boolean>(false);
    const [arrayEPS, setArrayEPS] = useState<EPS[]>([]);
    const [arrayTypeReport, setArrayTypeReport] = useState<TypeReport[]>([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [show2, setShow2] = useState(false);
    const [showNoti, setShowNoti] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    type formaHtml = React.FormEvent<HTMLFormElement>;
    const handleClose2 = () => setShow2(false);
    const formRef = useRef<HTMLFormElement>(null);
    //function to error the Token on the time, using when token is invalid or expired
    const [search, setSearch] = useState("");
    const [arrayUsers, setArrayUsers] = useState<User>();
    const [arrayIPSUpdate, setArrayIPSUpdate] = useState<IPS[]>([]);
    const [showFinal, setShowFinal] = useState(false);
    const [proccess, setProccess] = useState<boolean>();

    let { eps, name, description, doubleLink, object } =
        useForm<TypeReport>(
            new TypeReport(
                0,
                "",
                "",
                "",
                false
            ) // Incluye `id_municipio` con un valor inicial
        );

    const [objTypeReport, setObjTypeReport] = useState<TypeReport>(
        new TypeReport(
            0,
            "",
            "",
            "",
            true
        )
    );


    const cleanBox = (form: HTMLFormElement) => {
        form.reset();

        object.name = "";
        object.description = "";
        object.eps = "";


        (form.querySelector('[name="name"]') as HTMLInputElement).value =
            "";
        (form.querySelector('[name="description"]') as HTMLInputElement).value =
            "";
        (form.querySelector('[name="eps"]') as HTMLInputElement).value =
            "";

        form.classList.remove("was-validated");
    };



    const handleTokenError = () => {
        navigate("/");
    };

    const getOneTypeReport = async (id: number) => {
        try {
            const urlGetUser = ApiBack.GET_TYPE_REPORT_ID + "?id=" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);

            setObjTypeReport(result);
            setShow(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getMunicipality = async () => {
        try {
            const urlGetMunc = ApiBack.lIST_EPS_ACTIVE;
            const result = await ServicePrivate.requestGET(urlGetMunc);
            setArrayEPS(result);
        } catch (error) {
            console.error("Error fetching eps array:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };
    const getIPSUpdate = async () => {
        try {
            const urlGetMunc = ApiBack.IPS_UPDATE_STATUS;
            const result = await ServicePrivate.requestGET(urlGetMunc);

            if (result) {
                setArrayIPSUpdate(result);
            }
            if (result.error) {
                MessageToastify("error", result.error, 3000)
            }
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const handleShowCreate = async () => {
        setShow2(true);
        getMunicipality();

    }

    const getAllTypeReport = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.LIST_TYPE_REPORT_ALL);

            if (results) {
                const payload = results || [];
                setArrayTypeReport(payload);
                setLoading(false);
            } else {
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching EPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const getProfessionals = async () => {
        try {
            const token: any = localStorage.getItem("access");
            if (!token) {
                handleTokenError();
                return;
            }
            const decoded: any = jwtDecode(token);

            if (decoded && decoded.role) {
                setArrayUsers(decoded);
                setLoading(false);
                return;
            } else {
                console.error("El token no contiene información de usuario válida.");
                handleTokenError();
            }

        } catch (error) {
            console.error("Error fetching professionals:", error);
            setLoading(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    3000
                );
                return;
            }

            const formData = {
                name: object.name,
                description: object.description,
                eps: object.eps,
            };

            const response = await ServicePrivate.requestPOST(
                ApiBack.CREATE_TYPE_REPORT_ALL,
                formData
            );

            console.log(response);


            if (response.error) {
                setProcess(false);
                MessageToastify(
                    "error",
                    `Error al momento de crear el tipo de reporte: ${response.error}`,
                    3000
                );

            } else {
                setProcess(false);
                handleClose2();
                getAllTypeReport();
                MessageToastify("success", "El tipo de reporte ha sido creado correctamente.", 3000);
                cleanBox(form)
            }
        } catch (error) {
            setProcess(false);
            console.log(error);
            
            MessageToastify(
                "error",
                "Error en el servicio de crear: "+ error,
                3000
            );
        }
    };

    useEffect(() => {
        getAllTypeReport();
        getProfessionals();
        getIPSUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const updateSupportDetails = async (myTypeReportid: number, isActive: boolean) => {
        setProccess(true);

        try {
            // Encuentra el soporte por ID en el array
            const updatedTypeReport = arrayTypeReport.find((myTypeReport) => myTypeReport.id === myTypeReportid);

            if (!updatedTypeReport) {
                console.error("Soporte no encontrado");
                return;
            }

            // Crea un objeto con el valor de is_active basado en el parámetro
            const updatedObject = {
                is_active: isActive,
            };
            const urlUpdate = ApiBack.UPDATE_STATE_TYPE_REPORT + "?id=" + myTypeReportid;
            const response = await ServicePrivate.requestPUT(
                urlUpdate,
                updatedObject
            );

            if (response.data.OK) {
                MessageToastify(
                    "error",
                    "Error en el momento de Actualizar el estado del tipo de reporte.",
                    3000
                );
                getAllTypeReport();
            } else {
                MessageToastify("success", "El estado del tipo de reporte esta actualizado correctamente.", 3000);
                setShowFinal(false);
                getAllTypeReport();
            }
        } catch (error) {
            console.error("Error actualizando el estado de la EPS:", error);
            MessageToastify(
                "error",
                "Error en el momento de actualizar el estado del tipo de reporte en el servidor, contactar con TI.",
                3000
            );
            setShow(false);
        } finally {
            setProccess(false);
            setShow(false);
        }
    };

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-4">
                                        <h4 className="card-title fs-4 fw-bold">
                                            <i className="fa-solid fa-list"></i>&nbsp;Listado de tipos de reporte
                                        </h4>

                                    </div>
                                    <div className="col-lg-6 col-sm-4">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => handleShowCreate()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Crear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-center">
                                    <div className="col-lg-2 col-md-2">
                                        <p>
                                            Total de tipos de reporte:&nbsp;
                                            <b className="fw-bold">{arrayTypeReport.length}</b>
                                        </p>
                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>

                                    <table className="table table-striped table-sm table-hover table-sm">
                                        <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                <th style={{ width: "15%" }}>Nombre EPS</th>
                                                <th style={{ width: "75%" }}>Tipo de reporte</th>
                                                <th style={{ width: "10%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-group-divider ">
                                            {arrayTypeReport.map((myIps, count) => (
                                                <tr key={count + 1}>
                                                    <td>
                                                        <span className={`cursor-pointer ${myIps.is_active
                                                            ? ""
                                                            : "text-gray"
                                                            }`}>
                                                            {myIps.eps__name_eps}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`cursor-pointer ${myIps.is_active
                                                            ? ""
                                                            : "text-gray"
                                                            }`}>
                                                            {myIps.name}
                                                        </span>
                                                    </td>
                                                    <td className="d-flex justify-content-center">
                                                        {arrayUsers?.role === "ADMINISTRADOR" ? (
                                                            <>
                                                                <button
                                                                    className={
                                                                        myIps.is_active
                                                                            ? "badge fs-6 py-1 pe-1 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                                                            : "badge fs-6 py-1 pe-3 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                                    }
                                                                    type="button"
                                                                    onClick={() => getOneTypeReport(myIps.id)}

                                                                >
                                                                    {myIps.is_active ? (
                                                                        <>
                                                                            <i className="fa-regular fa-circle-xmark"></i>
                                                                            &nbsp;Inactivar
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="fa-regular fa-circle-check"></i>
                                                                            &nbsp;Activar
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </>
                                                        ) : ("")}

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>

                                <Modal
                                    show={show2}
                                    onHide={handleClose2}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            <i className="fa-solid fa-folder-plus"></i>
                                            &nbsp;Formulario de creación
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Form
                                        className="forms-sample"
                                        validated={process}
                                        onSubmit={sendForm}
                                        noValidate
                                        ref={formRef}
                                    >
                                        <Modal.Body>
                                            {/* Campo para nombre_ips */}
                                            <Form.Group controlId="name" className="mb-3 w-100">
                                                <Form.Label
                                                    className="fw-bold mb-2 mt-2"
                                                    htmlFor="name"
                                                >
                                                    Nombre del tipo de reporte:
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    id="name"
                                                    placeholder="Escriba el nombre del tipo de requimiento."
                                                    value={name}
                                                    onChange={(e) => {
                                                        let value = e.target.value.toUpperCase();
                                                        if (
                                                            /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/.test(value) &&
                                                            value.length <= 60
                                                        ) {
                                                            e.target.value = value; // Establece el valor en mayúsculas
                                                            doubleLink(e);
                                                        }
                                                    }}
                                                    autoComplete="off"
                                                    maxLength={60}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Nombre de la EPS es obligatorio.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group controlId="description" className="mb-3 w-100">
                                                <Form.Label
                                                    className="fw-bold mb-2 mt-2"
                                                    htmlFor="description"
                                                >
                                                    Descripción:
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="description"
                                                    className="form-control"
                                                    id="description"
                                                    placeholder="Escriba la descripción si es necesario."
                                                    value={description}
                                                    onChange={(e) => {
                                                        let value = e.target.value.toUpperCase(); // Convierte a mayúsculas
                                                        // Validar que solo contenga letras y limitar a 60 caracteres
                                                        if (
                                                            /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/.test(value) &&
                                                            value.length <= 60
                                                        ) {
                                                            e.target.value = value; // Establece el valor en mayúsculas
                                                            doubleLink(e); // Llama a tu función existente
                                                        }
                                                    }}
                                                    autoComplete="off"
                                                    maxLength={250}
                                                />
                                            </Form.Group>
                                            <Form.Group
                                                controlId="eps"
                                                className="mb-3 w-100"
                                            >
                                                <Form.Label
                                                    className="fw-bold mb-2 mt-2"
                                                    htmlFor="eps"
                                                >
                                                    EPS:
                                                </Form.Label>
                                                <Form.Select
                                                    required
                                                    id="eps"
                                                    name="eps"
                                                    value={eps}
                                                    onChange={doubleLink}
                                                >
                                                    <option value="">Selecciona la eps</option>
                                                    {arrayEPS.map((municipio) => (
                                                        <option key={municipio.id} value={municipio.id}>
                                                            {municipio.name_eps}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    EL municipio es obligatorio.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleClose2}>
                                                <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                                onClick={() => { }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                            </Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>

                                <Modal
                                    show={show}
                                    onHide={handleClose}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            {objTypeReport.is_active ? "Inactivar el tipo de reporte" : "Activar el tipo de reporte"}
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        ¿Realmente desea cambiar el estado del tipo de reporte?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="danger"
                                            onClick={() => {
                                                setShow(false);
                                            }}
                                        >
                                            <i className="fa-solid fa-backward"></i>
                                            &nbsp;Cancelar
                                        </Button>
                                        <Button
                                            variant="success"
                                            onClick={() => {
                                                updateSupportDetails(objTypeReport.id, !objTypeReport.is_active);
                                            }}
                                        >
                                            <i className="fa-solid fa-circle-check"></i>
                                            &nbsp;Confirmar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
};
